import { useEffect, useState } from "react";
import { MdClose } from "react-icons/md";

export interface Filters {
    verticals: string[];
    payoutRange: { min: string; max: string };
    payout_type: "fixed" | "variable" | "";
    state_list: string[];
    campaign_types: ("Calls" | "Leads" | "Traffic")[];
}
interface OfferFiltersProps {
    value: Filters;
    onChange: (filters: Filters) => void;
    onApply: (filters: Record<string, any>) => void;
    onClose: () => void;
}
export function OfferFilters({
    value,
    onChange,
    onApply,
    onClose,
}: OfferFiltersProps) {

    const filters = value;

    const handlePayoutTypeChange = (type: "fixed" | "variable" | "") => {
        if (type === "variable") {
            onChange({ ...filters, payout_type: type, payoutRange: { min: "", max: "" } });
        } else {
            onChange({ ...filters, payout_type: type });
        }
    };
    const handleCampaignToggle = (type: "Calls" | "Leads" | "Traffic") =>
        onChange({
            ...filters,
            campaign_types: filters.campaign_types.includes(type)
                ? filters.campaign_types.filter((t) => t !== type)
                : [...filters.campaign_types, type],
        });
    const clearFilters = () =>
        onChange({
            ...filters,
            payoutRange: { min: "", max: "" },
            state_list: [],
            payout_type: "",
            campaign_types: [],
        });

    const applyFilters = () => {
        const params: Record<string, any> = {};

        if (filters.payout_type) {
            params.payout_type = filters.payout_type;
        }
        if (filters.campaign_types.length > 0) {
            params.campaign_types = [...filters.campaign_types];
        }
        onApply(params);
        onClose();
    };

    return (
        <div className="absolute top-full right-0 mt-2 w-80 bg-white rounded-xl shadow-lg border border-gray-200 z-30">
            <div className="p-4">
                <div className="flex items-center justify-between mb-4">
                    <h3 className="text-lg font-semibold text-[#333]">Filters</h3>
                    <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded">
                        <MdClose size={20} />
                    </button>
                </div>

                <div className="mb-6">
                    <h4 className="text-sm font-semibold text-[#606060] mb-3">Payout Type</h4>
                    <div className="flex flex-col gap-2">
                        <label className="flex items-center gap-2">
                            <input
                                type="radio"
                                name="payout_type"
                                value=""
                                checked={filters.payout_type === ""}
                                onChange={() => handlePayoutTypeChange("")}
                            />
                            All
                        </label>
                        <label className="flex items-center gap-2">
                            <input
                                type="radio"
                                name="payout_type"
                                value="fixed"
                                checked={filters.payout_type === "fixed"}
                                onChange={() => handlePayoutTypeChange("fixed")}
                            />
                            Fixed
                        </label>
                        <label className="flex items-center gap-2">
                            <input
                                type="radio"
                                name="payout_type"
                                value="variable"
                                checked={filters.payout_type === "variable"}
                                onChange={() => handlePayoutTypeChange("variable")}
                            />
                            Variable
                        </label>
                    </div>
                </div>


                <div className="mb-6">
                    <h4 className="text-sm font-semibold text-[#606060] mb-3">Campaign Types</h4>
                    <div className="space-y-2">
                        {["Calls", "Leads", "Traffic"].map((type) => (
                            <label key={type} className="flex items-center cursor-pointer">
                                <input
                                    type="checkbox"
                                    checked={filters.campaign_types.includes(type as any)}
                                    onChange={() => handleCampaignToggle(type as any)}
                                    className="mr-3 rounded border-gray-300 text-[#F97316] focus:ring-[#F97316]"
                                />
                                <span className="text-sm text-[#333]">{type}</span>
                            </label>
                        ))}
                    </div>
                </div>

                {/* Buttons */}
                <div className="flex gap-3">
                    <button
                        onClick={clearFilters}
                        className="flex-1 px-4 py-2 text-sm font-medium text-[#606060] border border-gray-300 rounded-lg hover:bg-gray-50"
                    >
                        Clear All
                    </button>
                    <button
                        onClick={applyFilters}
                        className="flex-1 px-4 py-2 text-sm font-medium bg-[#F97316] text-white rounded-lg hover:bg-orange-600"
                    >
                        Apply
                    </button>
                </div>
            </div >
        </div >
    );
}
